module.exports = __webpack_public_path__ + "static/media/foto2.31fc05ac.png";